module.exports = __webpack_public_path__ + "static/landingpage_icons_v2-06-a3366a346e31418ea93f113456dd1a33.png";